/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import LinkCell from '@atlassian/jira-common-directory-v2/src/components/link-cell/view.tsx';
import { TransitionComponent } from '@atlassian/jira-common-directory-v2/src/components/transition-component';
import { useIntl } from '@atlassian/jira-intl';
import { formatDateUTC } from '@atlassian/jira-portfolio-3-common/src/date-manipulation/format.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { TRASHED_STATUS } from '../../../../../common/constants';
import messages from './messages';
import type { Props } from './types';

const PlanCell = ({ plan, onClick, status }: Props) => {
	const href = plan ? `/jira/plans/${plan.id}` : '';
	const { formatMessage } = useIntl();
	const planTitle = plan?.title || formatMessage(messages.untitledPlan);

	return status === TRASHED_STATUS ? (
		<div css={containerStyles} data-plan={plan ? plan.id : ''}>
			<div css={labelStyles}>{planTitle}</div>
		</div>
	) : (
		<ContextualAnalyticsData
			attributes={{ date: formatDateUTC(Date.now(), 'YYYY-MM-DD HH:mm:ss') }}
		>
			<div css={containerStyles} data-plan={plan ? plan.id : ''}>
				<TransitionComponent href={href} onClick={onClick}>
					{() => (
						<div css={labelStyles}>
							<LinkCell href={href} caption={planTitle} onClick={onClick} />
						</div>
					)}
				</TransitionComponent>
			</div>
		</ContextualAnalyticsData>
	);
};

export default withFireUiAnalytics({ onClick: 'plan' })(PlanCell);

const containerStyles = css({
	display: 'inline-flex',
	alignItems: 'center',
	maxWidth: '100%',
});

const labelStyles = css({
	marginLeft: token('space.150', '16px'),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});
